class LoadMore extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      pagination: '.pagination',
      loader: '.load-more-loader',
      main: '.load-more-grid',
      item: '.load-more-grid-item',
    };

    this.elements = this.getElements();
    if (Object.keys(this.elements).length === 0) return;

    this.loading = false;
    this.scrollEvent();
  }

  getElements() {
    const container = this;
    return container
      ? {
          container,
          pagination: container.querySelector(this.selectors.pagination),
          loader: container.querySelector(this.selectors.loader),
          main: container.querySelector(this.selectors.main),
        }
      : {};
  }

  scrollEvent() {
    this.infiniteObserver = new IntersectionObserver(([entry], observer) => {
      if (entry.isIntersecting) {
        observer.unobserve(entry.target);
        this.loadNextPage();
      }
    }, {});

    const lastItem = this.querySelector(`${this.selectors.item}:last-child`);
    if (lastItem) {
      this.infiniteObserver.observe(lastItem);
    }
  }

  setLoading(value) {
    if (value) {
      this.loading = true;
      this.elements.loader.classList.add('loading');
    } else {
      this.loading = false;
      this.elements.loader.classList.remove('loading');
    }
  }

  loadNextPage() {
    if (this.loading) {
      return;
    }

    const nextLink = this.elements.pagination ? this.elements.pagination.querySelector('.next a') : null;
    const nextUrl = nextLink ? nextLink.getAttribute('href') : null;
    if (!nextUrl || nextUrl === '#') {
      return;
    }

    this.setLoading(true);

    const sectionId = {
      collection: 'main-collection-product-grid',
      'collection.variant': 'main-collection-product-grid',
      search: 'main-search-product-grid',
      blog: 'main-blog',
    };

    fetch(`${nextUrl}&sections=${sectionId[Shopify.template]}`)
      .then(response => response.json())
      .then(data => {
        this.setLoading(false);
        this.pageLoaded(data[sectionId[Shopify.template]]);
      });
  }

  pageLoaded(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newItems = doc.querySelectorAll(this.selectors.item);
    newItems.forEach(newItem => this.elements.main.append(newItem));

    this.infiniteObserver.observe(newItems[newItems.length - 1]);

    this.elements.pagination.innerHTML = doc.querySelector(this.selectors.pagination).innerHTML;

    if (Shopify.template.includes('collection') && Yotpo) {
      const api = new Yotpo.API(yotpo);
      api.refreshWidgets();
      document.dispatchEvent(new Event('collection.update'));
    }

    if (Shopify.template === 'collection.variant') {
      showProductsByVoltage();
    }
  }
}

customElements.define('load-more', LoadMore);
